import { faArrowRotateForward } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState } from 'react';
import VoxelAlertDialog from '../../../components/voxel/Dialogs/VoxelAlertDialog';
import VoxelDialogActionCancel from '../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelLink from '../../../components/voxel/Link/VoxelLink';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import { TeamMenuChoices } from '../../TeamPage/TeamPage';

export interface MonthSettingsProps {
  project: ProjectGq;
  disabled?: boolean;
  reload: () => Promise<unknown>;
}

const MonthSettings: React.FC<MonthSettingsProps> = ({ project, reload, disabled }) => {
  const formatMonths = (startDate?: string, endDate?: string) => {
    if (!startDate || !endDate) return '-';
    return `${moment.utc(startDate).format('MMM YYYY')} - ${moment
      .utc(endDate)
      .format('MMM YYYY')}`;
  };

  const [loading, setLoading] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);

  // Update keyword data
  const mutation = projectsApiService.mutations.projects.useUpdateProjectKeywordVolumes();

  const handleAction = () => {
    setLoading(true);
    setOpenWarning(false);
    mutation({
      keywordQuery: {
        filtering: { projectId: project.id },
        paging: null,
        sorting: null,
        selecting: null,
        excludeSelectedFilter: null,
      },
      updateEntireProject: true,
    })
      .then(reload)
      .finally(() => setLoading(false));
  };

  return (
    <VoxelFormPanel
      disabled={disabled}
      title={<span>Keyword periods</span>}
      subtitle={
        <>
          The keyword data period is automatically set when (1) collecting the first keyword data,
          or (2) when updating all keyword data.
        </>
      }
    >
      <VoxelFormPanelContent>
        <VoxelText variant="bread-medium" color="dark">
          {formatMonths(project.keywordMonth36Start, project.keywordMonth36End)}
        </VoxelText>
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Update keyword data'}
          onClick={() => setOpenWarning(true)}
          disabled={disabled}
          color="gray"
          endIcon={<FontAwesomeIcon icon={faArrowRotateForward} />}
        />
      </VoxelPanelActions>
      <VoxelAlertDialog
        title="Update keyword data"
        severity="warning"
        open={openWarning}
        onClose={() => setOpenWarning(false)}
      >
        <VoxelDialogContent>
          <VoxelText>
            The following action will trigger a refetch of all keywords in the project, including
            archived keywords.
            <br></br>
            <br></br>
            Note: This action requires that you have enough{' '}
            <VoxelLink href={'/team/' + TeamMenuChoices.Usage} openInNewIcon openInNewTab>
              monthly capacity
            </VoxelLink>{' '}
            left on your account.
          </VoxelText>
        </VoxelDialogContent>
        <VoxelDialogActions>
          <VoxelDialogActionCancel onClick={() => setOpenWarning(false)} />
          <VoxelDialogActionSubmit
            onClick={handleAction}
            title={'Refetch keywords'}
            endIcon={<FontAwesomeIcon icon={faArrowRotateForward} />}
          />
        </VoxelDialogActions>
      </VoxelAlertDialog>
    </VoxelFormPanel>
  );
};

export default MonthSettings;
